(function($) {
  $(document).ready(function() {
    const body = $('body');

    $('body').on('click', '.back-to-top', function() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });

    // Helper: add to cart via fetch (works for guests and logged-in users)
    function addToCart(variantId, quantity, callback) {
      if (!variantId) {
        console.error('addToCart: No variant ID provided');
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: quantity || 1
          }]
        })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(err) { throw err; });
        }
        return response.json();
      })
      .then(function(data) {
        console.log('Added to cart:', data);
        if (typeof callback === 'function') callback(data);
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
        alert(err.description || 'Could not add item to cart. Please try again.');
      });
    }

    $('body').on('click', '.custom-add-to-cart-btn', function() {
      const me = $(this);
      const id = me.data('id');

      addToCart(id, 1, function() {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });

        setTimeout(function() {
          $('body .bg-minicart').addClass('active');
          $('body .minicart').addClass('active');
        }, 1100);
      });
    });

    $('body').on('click', '.minicart .mini-content .mini-cart-head .close-mini-cart', function() {
      $('body .bg-minicart').removeClass('active');
      $('body .minicart').removeClass('active');

      if ($('body .modal-backdrop.show').length > 0) {
        $('body .modal-backdrop.show').removeClass('show').hide();
      }
    });

    $('body').on('click', '.bg-minicart', function() {
      $('body .bg-minicart').removeClass('active');
      $('body .minicart').removeClass('active');

      if ($('body .modal-backdrop.show').length > 0) {
        $('body .modal-backdrop.show').removeClass('show').hide();
      }
    });

    $('body').on('click', '.cart-icon', function() {
      setTimeout(function() {
        $('body .bg-minicart').addClass('active');
        $('body .minicart').addClass('active');

        if ($('body .modal-backdrop.show').length > 0) {
          $('body .modal-backdrop.show').removeClass('show').hide();
        }
      }, 200);
    });
    
    if (body.hasClass('template-product')) {
      $('body .product-details-content .pro-details-quality .cart-plus-minus').prepend('<label>Quantity</label>')
      
      var acc = document.getElementsByClassName("accordion");
      var i;
      
      for (i = 0; i < acc.length; i++) {
        if (acc[i].classList.contains('product-details')) {
          acc[i].classList.toggle("active");

          var panel = acc[i].nextElementSibling;
          
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        }
        
        acc[i].addEventListener("click", function() {
          this.classList.toggle("active");
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }

      $('body').on('click', '.modal-backdrop.show', function() {
        $('body .bg-minicart').removeClass('active');
        $('body .minicart').removeClass('active');

        $('body .modal-backdrop.show').removeClass('show').hide();
      });

      $('body').on('click', '#AddToCart', function() {
        const me = $(this);
        const variantId = me.data('product-id');
        const qty = $('body .cart-plus-minus-box').val();

        addToCart(variantId, qty, function() {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });

          setTimeout(function() {
            $('body .bg-minicart').addClass('active');
            $('body .minicart').addClass('active');
          }, 1100);
        });
      });
    }
  
    if (body.hasClass('template-collection')) {
      $('body .custom-sidebar > div > section h5').each(function() {
        const me = $(this);

        me.click(function() {
          me.next().toggleClass('show-collection');

          if (me.next().hasClass('show-collection')) {
            me.find('span').text('-');
          } else {
            me.find('span').text('+');
          }
        });
      });
      
      if ($('.subcollection-slider').length > 0) {
        $('.shop-area-container .shop-area-sidebar .filter-form .blog-sidebar:last-of-type h5.title').trigger('click');
        
        $('.subcollection-slider').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 2500,
          arrows: true,
          prevArrow: "<span class='product-dec-icon product-dec-prev'><i class='sli sli-arrow-left'></i></span>",
          nextArrow: "<span class='product-dec-icon product-dec-next'><i class='sli sli-arrow-right'></i></span>",
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 450,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
  
        setTimeout(function() {
          $('body').on('mouseenter', '.subcollection-slider', function() {
            $('#shopify-section-collection-description .subcollection-slider .slick-arrow').css('opacity', 1);
          });
  
          $('body').on('mouseleave', '.subcollection-slider', function() {
            $('#shopify-section-collection-description .subcollection-slider .slick-arrow').css('opacity', 0);
          });
        }, 500);
      }
    }

    // PetsForHomes listings config
    var pfhConfig = {
      'dachshund-ramp-petsforhomes-australia': {
        url: 'https://petsforhomes.com.au/wp-json/adforest-child/v1/ads/569/5',
        label: 'Dachshunds',
        href: 'https://petsforhomes.com.au/dogs-puppies/dachshund/'
      },
      'cavoodle-toys-petsforhomes-australia': {
        url: 'https://petsforhomes.com.au/wp-json/adforest-child/v1/ads/562/5',
        label: 'Cavoodles',
        href: 'https://petsforhomes.com.au/dogs-puppies/cavoodle'
      },
      'labradoodle-toys-petsforhomes-australia': {
        url: 'https://petsforhomes.com.au/wp-json/adforest-child/v1/ads/596/5',
        label: 'Labradoodles',
        href: 'https://petsforhomes.com.au/dogs-puppies/labradoodle/'
      },
      'staffy-toys-petsforhomes-australia': {
        url: 'https://petsforhomes.com.au/wp-json/adforest-child/v1/ads/634/5',
        label: 'Staffies',
        href: 'https://petsforhomes.com.au/dogs-puppies/staffy/'
      },
      'malshi-gifts-petsforhomes-australia': {
        url: 'https://petsforhomes.com.au/wp-json/adforest-child/v1/ads/601/5',
        label: 'Maltese Shih Tzus',
        href: 'https://petsforhomes.com.au/dogs-puppies/maltese-shih-tzu/'
      }
    };

    var bodyId = body.attr('id');

    if (pfhConfig[bodyId]) {
      var config = pfhConfig[bodyId];

      $.ajax({
        url: config.url,
        method: 'GET',
        dataType: 'json',
        success: function(response) {
          const responseResult = response.result;
          
          console.log(responseResult);

          if (responseResult.length > 0) {
            let resultHtml = '<h2><span>Browse hundreds of ' + config.label + ' for sale</span><a href="' + config.href + '" target="_blank">See More</a></h2>';
            
            resultHtml += '<div class="pfh-listings-container">';

            for (const item in responseResult) {
              resultHtml += '<div class="pfh-listing">';
                resultHtml += '<div class="listing-image"><img src="' + responseResult[item].featured_image + '" width="100%" height="auto" alt="' + responseResult[item].title + '" /></div>';
                resultHtml += '<div class="listing-details">';
                  resultHtml += '<h4>' + responseResult[item].title + '</h4>';
                  resultHtml += '<p class="listing-location">' + responseResult[item].location + '</p>';
                  resultHtml += '<p class="listing-date">' + responseResult[item].date + '</p>';
                  resultHtml += '<p class="listing-price">$' + parseFloat(responseResult[item].price).toFixed(2) + '</p>';
                  resultHtml += '<div class="contact-seller-container"><a href="' + responseResult[item].url + '" target="_blank">Contact Seller</a></div>';
                resultHtml += '</div>';
              resultHtml += '</div>';
            }

            resultHtml += '</div>';

            body.find('.pfh-listings-section > .container').html(resultHtml);
          }
        },
        error: function(xhr, ajaxOptions, thrownError) {
          console.log(xhr, thrownError);
        }
      });
    }
  });
})(jQuery);

/* PFH 19 Oct 2026: on phones, reviews show about one screen, then a "Show all reviews" button. */
(function () {
  function setup() {
    var box = document.getElementById('looxReviews');
    if (!box || box.dataset.pfhClamp) return;
    box.dataset.pfhClamp = '1';
    /* Loox rewrites the widget's own classes, so the state lives on the section around it. */
    var host = box.closest('.shopify-section') || box.parentElement;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pfh-reviews-more';
    btn.textContent = 'Show all reviews';
    btn.addEventListener('click', function () {
      host.classList.add('pfh-reviews-open');
      btn.remove();
    });
    box.insertAdjacentElement('afterend', btn);
    var check = function () {
      var tall = box.scrollHeight > 760;
      host.classList.toggle('pfh-reviews-clamped', tall && !host.classList.contains('pfh-reviews-open'));
      btn.hidden = !tall || host.classList.contains('pfh-reviews-open');
    };
    check();
    /* Loox fills its box late and in steps, so re-check for 20 seconds. */
    var tries = 0;
    var timer = setInterval(function () { check(); if (++tries > 40) clearInterval(timer); }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
